import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
// Plugins
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, catchError, map, throwError } from 'rxjs';
// Models
import { Response } from '@models/api/api.model';
// Shared
import { APP_HOST, ENDPOINTS } from '@shared/endpoints.enum';
import { API_PHP_URL_PART, API_PHP_URL_PART_WEB } from '@shared/config';
// Services
import { HelperService } from '@services/helper/helper.service';

@Injectable({
	providedIn: 'root'
})
export class HttpService {

	public constructor(
		private httpClient: HttpClient,
		private messageService: NzMessageService,
		private helperService: HelperService
	) { }

	public request<T, K extends Response>(
		method: string, 
		endpoint: ENDPOINTS | string, 
		host: APP_HOST, 
		body: T = null, 
		formDataConvert: boolean = false,
		skipErrorMessage: boolean = false,
		showSuccessMessage: boolean = false,
		includeWeb: boolean = false
	): Observable<K> {
		let url = this.constructUrl(endpoint, host, includeWeb);

		if (formDataConvert) body = this.helperService.objectToFormData(body) as T;

		let request: Observable<K> = null;
		
		if (!body) request = this.httpClient[method]<K>(url);
		else request = this.httpClient[method]<K>(url, body);

		return request.pipe(
			map((res: K) => {
				if ((!res?.result && res?.status != 'success') && !skipErrorMessage) {
					let message: string = res?.message || 'Internal server error';

					this.messageService?.error(message);
				}

				if ((res?.result || res?.status == 'success') && showSuccessMessage) this.messageService?.success('Success');

				return res;
			}),
			catchError((err: HttpErrorResponse) => this.handleError(err, skipErrorMessage))
		) as Observable<K>;
	}

	private constructUrl(endpoint: ENDPOINTS | string, host: APP_HOST, includeWeb: boolean = false): string {
		let hostUrl: string = environment[host];

		if (host == APP_HOST.PHP_LARAVEL) {
			return hostUrl + '/v1/admin/' + endpoint;
		} else {
			let urlPart: string = host == APP_HOST.PHP ? (includeWeb ? API_PHP_URL_PART_WEB : API_PHP_URL_PART) : '';
			
			return hostUrl + '/' + urlPart + endpoint;
		}
	}

	private handleError(err: HttpErrorResponse, skipErrorMessage: boolean): Observable<never> {
		let message: string = err?.error?.message || 'Internal server error';

		if (![401, 409].includes(err.status) && !skipErrorMessage) this.messageService?.error(message);

		return throwError(() => err);
	}
}